import { Select, Typography } from 'antd';
import { Page4Process } from '../../@types/ghePage4/types';

type Props = {
  process: Page4Process;
  options: string[];
  value: string[];
  disabled?: boolean;
  onChange?: (values: string[]) => void;
};

export const GheProcessSelectionPanel = ({
  process,
  options,
  value,
  disabled,
  onChange
}: Props) => {
  return (
    <div data-testid={`ghe-page4-selection-${process}`}>
      <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
        {process.toUpperCase()}
      </Typography.Text>
      <Select
        mode="multiple"
        disabled={disabled}
        style={{ width: '100%' }}
        placeholder={`Select ${process} analogues`}
        value={value}
        options={options.map(option => ({ label: option, value: option }))}
        onChange={onChange}
      />
    </div>
  );
};
